import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Table from '../../components/Table/Table/Table';
import BaseModal from '../../components/Modal/Base/BaseModal';
import CrudModal from '../../components/Modal/Crud/CrudModal';
import FileManagement from '../../components/Modal/File/FileManagement';
import ConfirmModal from '../../components/Modal/Confirm/ConfirmModal';
import ExcelImportResultModal from '../../components/Modal/ExcelImportResult/ExcelImportResultModal';
import Search from '../../components/Search/Search';

import { renderExpandedRow } from './components/ExpandeRow';
import { machineColumns, machineFormFields, machineSearchFormFields } from './context'
import { useMachine } from '../../stores/machine/MachineAction';
import { useMachineAPI } from '../../api/machine/useMachineAPI';
import { useFileAPI } from '../../api/file/useFileAPI';


import { FaInfo } from 'react-icons/fa';
import { PiFloppyDiskBold } from "react-icons/pi";
import {CiImageOff} from 'react-icons/ci';
import yclogo from '../../images/Logo.png';
import { FaTools } from 'react-icons/fa';
import './MachineManagement.css';


const MachineManagement = () => {
  const dispatch = useDispatch();
  const session = useSelector((state) => state.session.data);
  const machine = useSelector((state) => state.machine);
  const machineApi = useMachine();
  const machineDirectApi = useMachineAPI();
  const [modalTitle, setModalTitle] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [clickedRow, setClickedRow] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState(null);
  const [importResult, setImportResult] = useState(null);
  const [importResultOpen, setImportResultOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);

  // type 1 : 등록, 2 : 수정
  const openModal = (type, row = null) => {
    let action;
    let formFields = machineFormFields;
      if(type === 1){
        setModalTitle(<><FaTools style={{ marginRight: '8px' }} /> 설비 등록</>)
        action = addMachine;
      } else {
        setModalTitle(<><FaTools style={{ marginRight: '8px' }} /> 설비 수정</>)
        action = updateMachine;
      }
      setIsOpen(true);
    setContent(
    <CrudModal
      type={type}
      formFields={formFields}
      formDatas={row || {}}
      onClose={closeModal}
      onSubmit={action}
    />);
  };
    
const openFileModal = (row) => {
    if (!row) {
      return;
    }
    setIsOpen(true);
    setContent(
      <FileManagement
        row={row || clickedRow}
        fileCode={"Machine"}
        onClose={closeModal} 
      />);
    setModalTitle(<><PiFloppyDiskBold size={20} style={{ marginRight: '8px' }} /> 첨부파일 관리</>);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const searchMachine= (params = {}) => {
    if(!params) {
      params.companySeq = session.companySeq;
    }
    
    dispatch(machineApi.request.get(params));
  }

  const addMachine = async (data) => {
    data.companySeq = session.companySeq
    await machineApi.request.post(data)
    searchMachine({companySeq: session.companySeq, page: currentPage, size: 10});
  }

  const updateMachine = async (data) => {
    data.companySeq = session.companySeq
    await machineApi.request.put(data)
    searchMachine({companySeq: session.companySeq, page: currentPage, size: 10});
  }

  const deleteMachine = async (row) => {
    const params = [row.machineSeq]
    await machineApi.request.delete(params)
    searchMachine({companySeq: session.companySeq, page: currentPage, size: 10});
  }

  const promptDeleteMachine = useCallback((machine) => {
    if (!machine) {
      return;
    }
    
    setModalTitle(<><FaInfo style={{ marginRight: '8px' }} /> 알림</>);
    setContent(
      <ConfirmModal
        message={`"${machine.machineName}"을 삭제하시겠습니까?`}
        onConfirmAction={() => {
          deleteMachine(machine);
          closeModal(); 
        }}
        onCancelAction={closeModal} 
        confirmText="삭제"
        cancelText="취소"
      />);
    setIsOpen(true); 
  }, [deleteMachine, closeModal, setContent, setIsOpen, setModalTitle]);

  useEffect(() => {
        try {
          const params = {
            companySeq: session.companySeq,
            page: 1,
            size: 10
          };
          searchMachine(params);
          
        } catch (error) {
          console.error('Error fetching Machine : ', error);
        } finally {
          //setIsLoading(false);
        }
  }, [dispatch, session]);

  const machinePaging = (page) => {
    setCurrentPage(page);
    const parmas = {
      companySeq : session.companySeq,
      page : page,
      size : 10
    }
    searchMachine(parmas)
  }

  const handleExcelDownload = async () => {
    await machineDirectApi.machine.download({ companySeq: session.companySeq });
  };

  const handleExcelUpload = async () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.xlsx,.xls';
    input.onchange = async () => {
      const files = Array.from(input.files || []);
      if (files.length === 0) return;
      const formData = new FormData();
      formData.append('file', files[0]);
      try {
        const result = await machineDirectApi.machine.import(formData);
        if (result && result.data) {
          setImportResult(result.data);
          setImportResultOpen(true);
        }
        searchMachine({ companySeq: session.companySeq, page: currentPage, size: 10 });
      } catch (e) {
        alert('엑셀 업로드 실패');
      }
    };
    input.click();
  };

  return (
    <div className="machine-management">
      <div className="machine-table-container">
        {/* <Search
          search={searchMachine}
          formFields={machineSearchFormFields}
        /> */}
        <Table
          title={<><FaTools style={{ marginRight: '8px' }} /> 설비 목록</>}
          className="machine-table"
          columns={machineColumns(openModal, promptDeleteMachine, openFileModal)}
          data={ machine.data }
          page={ machine.page }
          onAddClick={() => openModal(1)}
          renderExpandedRow={ renderExpandedRow }
          paging={ machinePaging }
          getRowId={(row) => row.machineSeq}
          // showCheckbox={true}
          showSearchBar={false}
          excelExport={handleExcelDownload}
          excelImport={handleExcelUpload}
        />
      </div>
      <BaseModal
        title={modalTitle}
        children={content}
        isOpen={isOpen}
        onClose={closeModal}
      />
      <ExcelImportResultModal
        isOpen={importResultOpen}
        onClose={() => setImportResultOpen(false)}
        result={importResult}
      />
    </div>
  );
};

export default MachineManagement;
